import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from 'src/app/models/user';

import { PermissionDirective } from '../../../core/directives/permission.directive';
import { RequiredUserRolesDirective } from '../../../core/directives/required-user-roles.directive';
import { SideMenuMapping, SideMenuNamesEnum } from '../../../core/utils/sidebar';
import { SideMenuItemComponent } from '../../../ui-kit/side-menu-item/side-menu-item.component';
import { SideMenuComponent } from '../../../ui-kit/side-menu/side-menu.component';

@Component({
  selector: 'app-sidebar-side-menu',
  templateUrl: './sidebar-side-menu.component.html',
  styleUrls: ['./sidebar-side-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SideMenuComponent, PermissionDirective, RequiredUserRolesDirective, SideMenuItemComponent],
})
export class SidebarSideMenuComponent {
  @Input() selectedSideMenuName: SideMenuNamesEnum;
  @Input() user: User;
  @Input() sideMenuMapping: SideMenuMapping;
}
